import React from 'react';
import { Building2, RefreshCw } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

export default function CompanySwitchModal({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  targetCompany,
  currentCompany 
}) {
  // Se não está aberto, não renderiza
  if (!isOpen) return null;
  
  // Se está voltando para empresa principal (targetCompany é null) e não tem empresa atual selecionada, não faz sentido
  // Mas se tem empresa atual selecionada e target é null, significa que está voltando para principal
  const isReturningToMain = targetCompany === null && currentCompany !== null;
  const isSwitchingToManaged = targetCompany !== null;
  
  // Se não é nem voltando nem trocando, não renderiza
  if (!isReturningToMain && !isSwitchingToManaged) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center sm:text-center">
          {/* Logo G2 */}
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-cyan-500 to-cyan-700 flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-3xl">G2</span>
            </div>
          </div>
          
          <DialogTitle className="text-xl font-semibold text-slate-900">
            Alterando Empresa
          </DialogTitle>
          
          <DialogDescription className="text-slate-600 mt-2">
            Você está mudando o contexto da plataforma para outra empresa.
          </DialogDescription>
        </DialogHeader>

        {/* Visualização da troca */}
        <div className="py-6">
          <div className="flex items-center justify-center gap-4">
            {/* Empresa atual */}
            <div className="flex-1 text-center">
              <div className="w-12 h-12 mx-auto rounded-lg bg-slate-100 flex items-center justify-center mb-2">
                <Building2 className="w-6 h-6 text-slate-400" />
              </div>
              <p className="text-xs text-slate-500">Atual</p>
              <p className="text-sm font-medium text-slate-700 truncate max-w-[120px] mx-auto">
                {currentCompany?.nome || 'Empresa Principal'}
              </p>
            </div>

            {/* Seta */}
            <div className="flex-shrink-0">
              <RefreshCw className="w-6 h-6 text-cyan-600 animate-pulse" />
            </div>

            {/* Nova empresa */}
            <div className="flex-1 text-center">
              <div className="w-12 h-12 mx-auto rounded-lg bg-cyan-100 flex items-center justify-center mb-2">
                <Building2 className="w-6 h-6 text-cyan-600" />
              </div>
              <p className="text-xs text-slate-500">Nova</p>
              <p className="text-sm font-medium text-cyan-700 truncate max-w-[120px] mx-auto">
                {targetCompany?.nome || 'Empresa Principal'}
              </p>
            </div>
          </div>

          {/* Aviso */}
          <div className="mt-6 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-xs text-amber-800 text-center">
              Todos os dados exibidos serão atualizados para a empresa selecionada.
            </p>
          </div>
        </div>

        <DialogFooter className="flex gap-3 sm:justify-center">
          <Button 
            variant="outline" 
            onClick={onCancel}
            className="flex-1 sm:flex-none"
          >
            Cancelar
          </Button>
          <Button 
            onClick={onConfirm}
            className="flex-1 sm:flex-none bg-cyan-600 hover:bg-cyan-700"
            data-testid="confirm-company-switch"
          >
            Confirmar Troca
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
